import { render, staticRenderFns } from "./upgradeUser.vue?vue&type=template&id=5d94126e&scoped=true&"
import script from "./upgradeUser.vue?vue&type=script&lang=js&"
export * from "./upgradeUser.vue?vue&type=script&lang=js&"
import style0 from "./upgradeUser.vue?vue&type=style&index=0&id=5d94126e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d94126e",
  null
  
)

component.options.__file = "upgradeUser.vue"
export default component.exports